<template>
  <tr class='w-table-data-footer fixed-sum-table-row'>
    <slot
      name='footer-inner-append'
      :aggregations='aggregations'
    >
      <td
        v-for='(header, index) in headers'
        :key='index'
        :class='getClasses(header)'
      >
        <span>{{ getAggregation(header) }}</span>
      </td>
    </slot>
  </tr>
</template>

<script>
const _getAlignment = (header) => {
  return header.alignValue || header.align
    ? `text-${header.alignValue ?? header.align}`
    : '';
}

export default {
  name: 'WorkDataTableFooter',
  props: {
    headers: { type: Array, required: true },
    aggregations: { type: Object, required: false },
  },
  methods: {
    getClasses(header) {
      const alignment = _getAlignment(header);
      return `${alignment}`;
    },
    getAggregation(header) {
      if (header == undefined || this.aggregations == undefined)
        return
      const aggregationValue = this.aggregations[header.value];
      if (aggregationValue == undefined) { return undefined }

      return header.presentWith != undefined ? header.presentWith(aggregationValue) : aggregationValue;
    },
  }
};
</script>

<style lang='scss' scoped>
.w-table-data-footer td {
  cursor: default !important;
}
</style>
